<template>
  <b-modal ref="vouchers-modal-ref" hide-footer hide-header>
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">Vouchers</h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>

      <div class="voucher-modal-body">
        <p>
          Vouchers for your travel arrangements will be displayed below.
          Typically these are electronic vouchers and there is no need to print
          them off. Where physical documents are required, these will be posted
          to the address on this itinerary ahead of travel.
        </p>

        <div class="d-flex justify-content-end mb-3">
          <button class="btn voucher-btn-info" @click.prevent="toggleExpand">
            {{ !this.expanded ? "Expand All Dates" : "Collapse All Dates" }}
          </button>
        </div>

        <b-row
          v-for="(day, index) in itinerary.items"
          :key="index"
          :set="(showRow = false)"
        >
          <b-col v-if="showBrick(day)">
            <b-row class="itinerary-time-date-container">
              <span
                v-if="!day.tourDay || displayDay(selectedItineraries, day.data)"
                v-show="checkItineraryDay(day.types)"
                class="itinerary-time-date"
                ><i class="material-icons mr-3"></i>{{ day.title_day }}
                {{ day.title_date }}</span
              ><span
                v-if="day.tourDay && displayDay(selectedItineraries, day.data)"
                class="itinerary-time-date-tour-day"
                >PRIVATE TOUR DAY {{ day.tourDay }}</span
              >
              <span />
            </b-row>
            <b-row v-for="(item, index2) in day.data" :key="index2">
              <b-col>
                <Tour
                  v-if="
                    (item.jsontype === 'tour' && item.brickid) ||
                    item.jsontype === 'rail'
                  "
                  ref="itineraryItemRef"
                  :item="item"
                  :expanded="expanded"
                  :booking="booking"
                  :param="generateBrickParam(item)"
                  :voucherEssential="voucherEssential(item)"
                  @scrollToAdditionalDocs="scrollIntoView"
                />

                <Accommodation
                  v-if="item.jsontype === 'hotel'"
                  ref="itineraryItemRef"
                  :item="item"
                  :expanded="expanded"
                  :booking="booking"
                  :param="generateBrickParam(item)"
                  :voucherEssential="voucherEssential(item)"
                  @scrollToAdditionalDocs="scrollIntoView"
                />

                <Vehicle
                  v-if="item.jsontype === 'vehicle'"
                  ref="itineraryItemRef"
                  :item="item"
                  :expanded="expanded"
                  :booking="booking"
                  :param="generateBrickParam(item)"
                  :voucherEssential="voucherEssential(item)"
                  @scrollToAdditionalDocs="scrollIntoView"
                />

                <Transfer
                  v-if="item.jsontype === 'transfer'"
                  ref="itineraryItemRef"
                  :item="item"
                  :expanded="expanded"
                  :booking="booking"
                  :param="generateBrickParam(item)"
                  :voucherEssential="voucherEssential(item)"
                  @scrollToAdditionalDocs="scrollIntoView"
                />

                <Wedding
                  v-if="item.jsontype === 'wedding'"
                  ref="itineraryItemRef"
                  :item="item"
                  :expanded="expanded"
                  :booking="booking"
                  :param="generateBrickParam(item)"
                  :voucherEssential="voucherEssential(item)"
                  @scrollToAdditionalDocs="scrollIntoView"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div
        v-if="additionalSupDocExist"
        class="voucher-modal-body"
        id="additionalSupDocs"
      >
        <div class="vtd-modal-header mt-4 mb-1 px-0">
          <h5 class="vtd-modal-title">Additional Documents</h5>
        </div>
        <p>Additional documents relating to your booking can be found here.</p>
        <p>
          Each document may, or may not, have a name that associates it to a
          particular item in your itinerary. You will need to check each
          document individually to determine which part of your itinerary it
          pertains to.
        </p>
        <!-- Display additional docs by group -->
        <div
          class="row align-items-center mb-1"
          v-for="group in additionalSupDocGroups"
          :key="group.shortname"
        >
          <div class="column col-12 text-none">
            <!-- Showing the name of each additional document group -->
            <div class="mb-2">
              <strong class="ng-binding">{{ group.shortname }}</strong>
            </div>
            <div
              class="row align-items-center justify-content-between mb-3 mx-0"
              v-for="index in group.doclist"
              :key="index"
            >
              <p class="col-md-9 m-0 p-0">
                {{ filenames[Number(index)] | replaceFilename }}
              </p>
              <div class="col-md-3 justify-self-end">
                <a
                  target="_blank"
                  :href="
                    'https://www.trailfinders.' +
                    returnSite +
                    '/tourdoc/bybookno/' +
                    bookingNumber +
                    '/' +
                    filenames[Number(index)]
                  "
                >
                  <button
                    class="btn btn-support btn-consultant m-auto btn-secondary"
                  >
                    <i class="material-icons">&#xE880;</i>View Document
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small
            >This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { getSite } from "@/lib/utilities";
import { mapActions, mapGetters, mapState } from "vuex";
import Tour from "@/modules/navigation/modals/vouchers-documents/bricks/tour.vue";
import Wedding from "@/modules/navigation/modals/vouchers-documents/bricks/wedding.vue";
import Vehicle from "@/modules/navigation/modals/vouchers-documents/bricks/vehicle.vue";
import Transfer from "@/modules/navigation/modals/vouchers-documents/bricks/transfer.vue";
import Accommodation from "@/modules/navigation/modals/vouchers-documents/bricks/accommodation.vue";

export default {
  components: {
    Accommodation,
    Vehicle,
    Transfer,
    Tour,
    Wedding,
  },
  data() {
    return {
      expanded: true,
      voucherSubItem: {},
      documentSubItem: {},
      filenames: [],
      selectedItineraries: [],
    };
  },
  computed: {
    ...mapState({
      booking: (state) => state.booking.booking,
    }),
    ...mapGetters({
      additionalSupDocExist: "booking/checkForAdditionalSupDocs",
      additionalSupDocIndexes: "booking/getAdditionalSupDocs",
      additionalSupDocGroups: "booking/getAdditionalSupDocGroups",
      bookingNumber: "booking/getBookingNumber",
      essInfo: "booking/getEssentialInfo",
      itinerary: "booking/getItinerary",
    }),
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
    returnSite() {
      return getSite();
    },
  },
  filters: {
    replaceFilename: (value) => {
      if (value) {
        value = value.replace(/_/g, " ");
        value = value.substring(0, value.indexOf("."));
        return value;
      }
      return "";
    },
  },
  mounted() {
    if (this.additionalSupDocExist) {
      this.filenames = this.essInfo.supplier_documents.filenames;
    }
  },
  methods: {
    ...mapActions({ setCurrentAreaAction: "faq/setCurrentAreaAction" }),
    async showModal(object) {
      this.$refs["vouchers-modal-ref"].show();
      if (object.submenu.length > 0) {
        object.submenu.map((sub) => {
          if (sub.partial === "TravelVoucherRef") {
            this.voucherSubItem = sub;
          }
        });
        object.submenu.map((sub) => {
          if (sub.partial === "AdditionalDocumentRef") {
            this.documentSubItem = sub;
          }
        });
      }
    },
    openVouchersModal() {
      this.$refs["TravelVoucherRef"].showModal(this.voucherSubItem);
    },
    openDocumentsModal() {
      this.$refs["AdditionalDocumentRef"].showModal(this.documentSubItem);
    },
    showEtrail(area) {
      if (area) {
        this.setCurrentAreaAction(area);
      }
    },
    closeModal() {
      this.$refs["vouchers-modal-ref"].hide();
    },
    checkItineraryDay(types) {
      const typeArr = [
        "tour",
        "hotel",
        "checkin",
        "vehicle",
        "flight",
        "rail",
        "transfer",
        "surf",
      ];
      return types.every((value) => typeArr.includes(value));
    },
    displayDay(ids, data) {
      let showDay = false;
      data.forEach((item, index) => {
        if (ids) {
          if (ids.includes(item.mainBookingId)) {
            showDay = true;
          }
        }
      });
      return showDay;
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    showBrick(data) {
      let show = false;
      data.data.map((item) => {
        if (
          item.jsontype === "tour" ||
          item.jsontype === "hotel" ||
          item.jsontype === "vehicle" ||
          item.jsontype === "wedding" ||
          item.jsontype === "transfer" ||
          item.jsontype === "rail"
        ) {
          show = true;
        }
      });
      return show;
    },
    scrollIntoView() {
      document
        .getElementById("additionalSupDocs")
        .scrollIntoView({ behavior: "smooth" });
    },
    generateBrickParam(item) {
      if (item.vouchno && item.tourtype !== "CRUISE") {
        if (item.tfvouch_status && item.tfvouch_status === "ISSUED") {
          return "viewTFVoucher";
        }
        if (item.vouchno.startsWith("BEDSONLINE")) {
          return "viewBedsOnlineVoucher";
        }
        if (item.vouchno.startsWith("VIATOR")) {
          return "viewViatorVoucher";
        }
      } else if (item.suppdoclink === "true") {
        if (item.supdocslist.length) {
          if (item.supdocslist.length > 1) {
            return "viewMultiple";
          } else if (item.supdocslist.length === 1) {
            if (item.supdocslist[0] !== "") {
              return "viewVoucher";
            } else {
              return "scrollToAdditionalDocs";
            }
          }
        } else {
          return "scrollToAdditionalDocs";
        }
      } else if (item.essentialInformation.voucherEssential.length > 0) {
        return "viewEssentialInfo";
      } else if (
        item.tfvouch_status === "NOT YET READY" ||
        item.tfvouch_status === "NOT REQUIRED"
      ) {
        return "viewVoucherInfo";
      }
      return "viewError";
    },
    voucherEssential(item) {
      if (item.essentialInformation.voucherEssential.length > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss"></style>
